
const digest = '38a080112b34accb170b6047cae0d5592261bc32541ffaa1ffba9f1c330493a7';
const classes = {"body":"_body_aukki_1"};
const css = `._body_aukki_1 {
  padding: 0;
  margin: 0 -10px;
  max-height: 380px;
  overflow: hidden;
  min-height: 300px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  